import { useEffect, useState } from 'react';
import {
  getTripartiteContract,
  saveTripartiteContract,
  setTripartiteFlow,
  sendTripartiteEcpSms,
  resetTripartiteEcp,
  resetTripartiteContract,
} from '../../../../../api/deals/tripartiteContract';
import setStep from '../../../../../api/deals/setStep';
import uploadDocumentToDeal from '../../../../../api/deals/uploadDocumentToDeal';
import Button from '../../../../../components/Button/Button';
import LoaderInline from '../../../../../components/Loader/LoaderInline';
import { DOCUMENT_TYPES_TRIPARTITE_CONTRACT } from '../../../../../constants';
import { ROLE_ADMIN } from '../../../../../constants/roles';
import { colors } from '../../../../../constants/colors';
import { textStyles } from '../../../../../constants/textStyles';
import alert from '../../../../../helpers/alert';
import extractErrorMessage from '../../../../../utils/extractErrorMessage';
import isUserHaveRole from '../../../../../utils/isUserHaveRole';
import ConfirmModal from '../../../../../components/Modal/ConfirmModal';
import StepControlButtons from '../StepControlButtons';
import Document, { ROLE_LABEL } from './Document';
import ContractForm from './ContractForm';
import { FLOW_ECP, FLOW_PRINT, canGoNext, ecpSmsPhone, flowKey, focusFirstError, formErrors, formFromValues, regenerateWarning, restartEcpWarning, savePayload, switchFlowWarning } from './form';
import { Banner, card, hint, title } from './parts';
import styles from './TripartiteContractStep.module.css';

// Ð¢ÐµÐºÑÑ Ð¾Ð²ÐµÑÐ»ÐµÑ = ÑÐ°Ð¼Ð° Ð¾Ð¿ÐµÑÐ°ÑÐ¸Ñ: ÑÐ°Ð½ÑÑÐµ Ð¾Ð´Ð¸Ð½ ÑÐ»Ð°Ð³ saving Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»
// Â«Ð¤Ð¾ÑÐ¼Ð¸ÑÑÐµÐ¼ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñâ¦Â» Ð¸ Ð¿ÑÐ¸ ÑÐ±ÑÐ¾ÑÐµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐµÐ¹, Ð¸ Ð¿ÑÐ¸ Ð¿ÐµÑÐµÑÐ¾Ð´Ðµ Ð½Ð°Ð·Ð°Ð´.
const BUSY_GENERATE = 'Ð¤Ð¾ÑÐ¼Ð¸ÑÑÐµÐ¼ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñâ¦';
const BUSY_RESET_ECP = 'Ð¡Ð±ÑÐ°ÑÑÐ²Ð°ÐµÐ¼ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸â¦';
const BUSY_RESET_STEP = 'Ð¡Ð±ÑÐ°ÑÑÐ²Ð°ÐµÐ¼ ÑÐ°Ð³â¦';

const TripartiteContractStep = ({ deal, prevStep, nextStep, update }) => {
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [state, setState] = useState(null);
  const [form, setForm] = useState(null);
  const [signedFile, setSignedFile] = useState(null);
  const [flow, setFlow] = useState(() => sessionStorage.getItem(flowKey(deal?.id)) || '');
  const [sendingSms, setSendingSms] = useState('');
  const [justGenerated, setJustGenerated] = useState(false);
  const [busyLabel, setBusyLabel] = useState('');
  const [navigating, setNavigating] = useState(false);
  const [confirm, setConfirm] = useState(null);

  const askOrRun = (needAsk, dialog, run) => {
    if (!needAsk) {
      run();
      return;
    }
    setConfirm({ ...dialog, run });
  };

  // keepForm: Ð¾Ð¿ÑÐ¾Ñ Ð¾ÑÐµÑÐµÐ´Ð¸ Ð­Ð¦Ð Ð¸Ð´ÑÑ ÑÐ°Ð· Ð² 5 ÑÐµÐºÑÐ½Ð´, Ð¸ Ð¿ÐµÑÐµÐ·Ð°Ð¿Ð¸ÑÑÐ²Ð°ÑÑ Ð¸Ð¼ ÑÐ¾ÑÐ¼Ñ
  // Ð½ÐµÐ»ÑÐ·Ñ â Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÐºÐ°Ðº ÑÐ°Ð· Ð¿ÑÐ°Ð²Ð¸Ñ Ð² Ð½ÐµÐ¹ ÑÐµÐ»ÐµÑÐ¾Ð½ Ð¸Ð»Ð¸ Ð°Ð´ÑÐµÑ.
  const applyResponse = (data, { keepForm = false } = {}) => {
    setState(data);
    if (!keepForm) setForm(formFromValues(data?.values || {}, data?.parties));
    if (data?.ecp) {
      const next = data.ecp.flow || '';
      setFlow(next);
      if (deal?.id) {
        if (next) sessionStorage.setItem(flowKey(deal.id), next);
        else sessionStorage.removeItem(flowKey(deal.id));
      }
    }
  };

  const load = () => {
    setLoading(true);
    setError('');
    getTripartiteContract(deal?.id)
      .then((res) => applyResponse(res?.data))
      .catch((e) => {
        setState({ available: false, loadError: true, forbidden: e?.response?.status === 403 });
        // 403 â ÑÑÐ¾ Ð½Ðµ ÑÐ±Ð¾Ð¹ ÑÐµÑÐ²Ð¸ÑÐ°, Ð° ÑÐ¾Ð»Ñ: Ð±ÐµÐ· ÑÐ°Ð·Ð´ÐµÐ»ÐµÐ½Ð¸Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¸Ð´Ð¸Ñ
        // Â«ÐÐ¾Ð²ÑÐ¾ÑÐ¸ÑÑÂ», ÐºÐ¾ÑÐ¾ÑÐ¾Ðµ Ð½Ð¸ÐºÐ¾Ð³Ð´Ð° Ð½Ðµ ÑÑÐ°Ð±Ð¾ÑÐ°ÐµÑ.
        setError(
          e?.response?.status === 403
            ? 'Ð¨Ð°Ð³ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾ÑÑÑÐ´Ð½Ð¸ÐºÐ°Ð¼ ÐÐ¦ â Ð¾Ð±ÑÐ°ÑÐ¸ÑÐµÑÑ Ðº Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑ.'
            : 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°'
        );
      })
      .finally(() => setLoading(false));
  };

  useEffect(load, [deal?.id]);

  useEffect(() => {
    if (flow !== FLOW_ECP) return undefined;
    if (state?.ecp?.stage !== 'waiting') return undefined;
    const timer = setInterval(() => {
      getTripartiteContract(deal?.id)
        .then((res) => applyResponse(res?.data, { keepForm: true }))
        .catch(() => {});
    }, 5000);
    return () => clearInterval(timer);
  }, [flow, deal?.id, state?.ecp?.stage, state?.ecp?.signedCount]);

  const setField = (section, key, value) => {
    setForm((prev) => ({ ...prev, [section]: { ...prev[section], [key]: value } }));
  };

  const { missing, invalid, blocked, isError } = formErrors(form, state?.missing, flow);

  const submit = () => {
    if (blocked.length) {
      const message = invalid.length ? 'ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð½ÑÐµ Ð¿Ð¾Ð»Ñ' : 'ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð½ÑÐµ Ð¿Ð¾Ð»Ñ';
      setError(message);
      focusFirstError(blocked);
      return;
    }
    const warning = regenerateWarning(state?.ecp, Boolean(state?.document || state?.signedDocument));
    askOrRun(
      Boolean(warning),
      { title: 'Ð¡ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾', text: warning, confirmText: 'Ð¡ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°ÑÑ' },
      () => {
        setBusyLabel(BUSY_GENERATE);
        setError('');
        saveTripartiteContract(savePayload(deal?.id, form, { confirmWipe: Boolean(warning) }))
          .then((res) => {
            applyResponse(res?.data);
            const url = res?.data?.document?.url;
            if (url && flow === FLOW_PRINT) window.open(url, '_blank', 'noopener,noreferrer');
            setJustGenerated(true);
          })
          .catch((e) => {
            const data = e?.response?.data;
            const message = data?.errorMessage || extractErrorMessage(data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ';
            setError(message);
            alert.error(message);
          })
          .finally(() => setBusyLabel(''));
      }
    );
  };

  const uploadSigned = () => {
    if (!signedFile) return;
    setUploading(true);
    setError('');
    uploadDocumentToDeal({
      dealId: deal?.id,
      fileTypeId: DOCUMENT_TYPES_TRIPARTITE_CONTRACT,
      file: signedFile,
      signed: true,
    })
      .then(() => getTripartiteContract(deal?.id))
      .then((res) => {
        applyResponse(res?.data);
        setSignedFile(null);
        alert.success('Ð¡ÐºÐ°Ð½ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½');
        update?.();
      })
      .catch((e) => {
        const data = e?.response?.data;
        const message = data?.errorMessage || extractErrorMessage(data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐºÐ°Ð½';
        setError(message);
        alert.error(message);
      })
      .finally(() => setUploading(false));
  };

  const sendEcp = (role) => {
    setSendingSms(role);
    sendTripartiteEcpSms({ dealId: deal?.id, role, phone: ecpSmsPhone(form, role) })
      .then((res) => {
        applyResponse(res?.data);
        alert.success(`Ð¡ÐÐ¡: ${ROLE_LABEL[role] || role}`);
      })
      .catch((e) => {
        const data = e?.response?.data;
        alert.error(data?.errorMessage || extractErrorMessage(data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡');
      })
      .finally(() => setSendingSms(''));
  };

  const requestEcp = (role) => {
    const signer = (state?.ecp?.signers || []).find((item) => item.role === role);
    if (signer?.status !== 'sms') {
      sendEcp(role);
      return;
    }
    askOrRun(
      true,
      {
        title: 'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾',
        text: 'ÐÐ»Ð¸ÐµÐ½ÑÑ Ð¿ÑÐ¸Ð´ÑÑ Ð½Ð¾Ð²Ð°Ñ ÑÑÑÐ»ÐºÐ° Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ.',
        confirmText: 'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ',
      },
      () => sendEcp(role)
    );
  };

  const restartEcp = () => {
    askOrRun(
      true,
      { title: 'Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸', text: restartEcpWarning(state?.ecp), confirmText: 'Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ' },
      () => {
        setBusyLabel(BUSY_RESET_ECP);
        resetTripartiteEcp({ dealId: deal?.id })
          .then((res) => {
            applyResponse(res?.data);
            alert.success('ÐÐ¾Ð´Ð¿Ð¸ÑÐ¸ ÑÐ±ÑÐ¾ÑÐµÐ½Ñ');
          })
          .catch((e) => {
            const data = e?.response?.data;
            alert.error(data?.errorMessage || extractErrorMessage(data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ±ÑÐ¾ÑÐ¸ÑÑ');
          })
          .finally(() => setBusyLabel(''));
      }
    );
  };

  const pickFlow = (next) => {
    const warning = switchFlowWarning(state?.ecp);
    askOrRun(
      Boolean(warning),
      { title: 'Ð¡Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ¸Ð¿ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ', text: warning, confirmText: 'Ð¡Ð¼ÐµÐ½Ð¸ÑÑ' },
      () => {
        setFlow(next);
        if (deal?.id) {
          if (next) sessionStorage.setItem(flowKey(deal.id), next);
          else sessionStorage.removeItem(flowKey(deal.id));
          setTripartiteFlow({ dealId: deal.id, flow: next || '' })
            .then((res) => applyResponse(res?.data))
            .catch((e) => {
              const data = e?.response?.data;
              alert.error(data?.errorMessage || extractErrorMessage(data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¼ÐµÐ½Ð¸ÑÑ ÑÐ¸Ð¿');
            });
        }
      }
    );
  };

  const resetStep = () => {
    askOrRun(
      true,
      { title: 'Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ ÑÐ°Ð³', text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¸ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ð±ÑÐ´ÑÑ ÑÐ´Ð°Ð»ÐµÐ½Ñ.', confirmText: 'Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ' },
      () => {
        setBusyLabel(BUSY_RESET_STEP);
        setError('');
        resetTripartiteContract({ dealId: deal?.id })
          .then((res) => {
            sessionStorage.removeItem(flowKey(deal?.id));
            setFlow('');
            setJustGenerated(false);
            setSignedFile(null);
            applyResponse(res?.data);
            alert.success('Ð¨Ð°Ð³ ÑÐ±ÑÐ¾ÑÐµÐ½');
          })
          .catch((e) => {
            const data = e?.response?.data;
            const message = data?.errorMessage || extractErrorMessage(data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ±ÑÐ¾ÑÐ¸ÑÑ';
            setError(message);
            alert.error(message);
          })
          .finally(() => setBusyLabel(''));
      }
    );
  };

  const goNext = () => {
    if (!nextStep) return;
    setStep({ dealId: deal?.id, step: nextStep }).then(() => update());
  };

  if (loading) return <LoaderInline />;
  if (state?.loadError) {
    return (
      <div style={{ padding: '24px 20px' }}>
        <Banner tone="err">{error || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°.'}</Banner>
        {state.forbidden ? null : <Button text="ÐÐ¾Ð²ÑÐ¾ÑÐ¸ÑÑ" fill onClick={load} />}
      </div>
    );
  }
  if (!state?.available) {
    return (
      <div style={{ padding: '24px 20px' }}>
        <p style={{ ...textStyles.formTitle, marginBottom: 16 }}>ÐÐ²ÑÐ¾ Ð½Ðµ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â ÑÑÐ¾Ñ ÑÐ°Ð³ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½.</p>
        <Button disabled={!nextStep} text="ÐÐ°Ð»ÐµÐµ" fill onClick={goNext} />
      </div>
    );
  }
  if (!form) return <LoaderInline />;

  const isAdmin = isUserHaveRole(ROLE_ADMIN);
  const resetLink = isAdmin ? (
    <span
      role="button"
      onClick={resetStep}
      style={{ color: colors.dimGray, cursor: 'pointer', textDecoration: 'underline', fontSize: 14 }}
    >
      Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ ÑÐ°Ð³
    </span>
  ) : null;

  const overlayLabel = busyLabel || (navigating ? 'ÐÐµÑÐµÑÐ¾Ð´Ð¸Ð¼â¦' : '');
  const overlay = overlayLabel ? (
    <div className={styles.overlay}>
      <div className={styles.overlayContent}>
        <LoaderInline />
        <p style={{ ...hint, margin: '16px 0 0' }}>{overlayLabel}</p>
      </div>
    </div>
  ) : null;

  const confirmModal = (
    <ConfirmModal
      isOpen={!!confirm}
      onClose={() => setConfirm(null)}
      title={confirm?.title}
      text={confirm?.text}
      confirmText={confirm?.confirmText || 'ÐÐ°'}
      cancelText="ÐÑÐ¼ÐµÐ½Ð°"
      onConfirm={() => {
        const run = confirm?.run;
        setConfirm(null);
        run?.();
      }}
    />
  );

  if (!flow) {
    const choice = {
      ...card,
      background: '#fff',
      cursor: 'pointer',
      marginBottom: 0,
      textAlign: 'left',
      font: 'inherit',
    };
    return (
      <div className={styles.form} style={{ padding: '24px 20px' }}>
        <StepControlButtons dealId={deal?.id} prevStep={prevStep} update={update} setLoading={setNavigating} />
        <p style={{ ...textStyles.formTitle, margin: '24px 0 4px' }}>Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ</p>
        <p style={{ ...hint, marginBottom: 16 }}>
          ÐºÑÐ¿Ð»Ð¸-Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ Ð°Ð²ÑÐ¾ÑÑÐ°Ð½ÑÐ¿Ð¾ÑÑÐ½Ð¾Ð³Ð¾ ÑÑÐµÐ´ÑÑÐ²Ð° Ð¸ Ð¾ÐºÐ°Ð·Ð°Ð½Ð¸Ñ Ð°Ð³ÐµÐ½ÑÑÐºÐ¸Ñ ÑÑÐ»ÑÐ³
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <button type="button" style={choice} onClick={() => pickFlow(FLOW_PRINT)}>
            <p style={{ ...title, margin: 0 }}>Ð Ð°ÑÐ¿ÐµÑÐ°ÑÐ°ÑÑ Ð¸ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°ÑÑ Ð² Ð¾ÑÐ¸ÑÐµ</p>
          </button>
          <button type="button" style={choice} onClick={() => pickFlow(FLOW_ECP)}>
            <p style={{ ...title, margin: 0 }}>ÐÐ¾Ð´Ð¿Ð¸ÑÐ°ÑÑ Ð­Ð¦Ð</p>
          </button>
        </div>
        {resetLink && <p style={{ ...hint, margin: '16px 0 0' }}>{resetLink}</p>}
        {overlay}
        {confirmModal}
      </div>
    );
  }

  const busy = !!busyLabel || uploading || !!sendingSms;
  const file = state?.document || state?.signedDocument;
  let banner = null;
  if (error) banner = <Banner tone="err">{error}</Banner>;
  else if (justGenerated && state?.document)
    banner = (
      <Banner tone="ok">
        {flow === FLOW_PRINT
          ? `ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ â ${state?.values?.number} ÑÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°Ð½ Ð¸ Ð¾ÑÐºÑÑÑ Ð² Ð½Ð¾Ð²Ð¾Ð¹ Ð²ÐºÐ»Ð°Ð´ÐºÐµ.`
          : `ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ â ${state?.values?.number} ÑÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°Ð½.`}
      </Banner>
    );
  else if (!state?.document && blocked.length)
    banner = (
      <Banner tone="warn">
        {invalid.length ? 'ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð½ÑÐµ Ð¿Ð¾Ð»Ñ.' : `ÐÐµ ÑÐ²Ð°ÑÐ°ÐµÑ ${missing.length} ${missing.length === 1 ? 'Ð¿Ð¾Ð»Ñ' : 'Ð¿Ð¾Ð»ÐµÐ¹'}.`}
      </Banner>
    );

  return (
    <div className={styles.form} style={{ padding: '24px 20px' }}>
      <StepControlButtons dealId={deal?.id} prevStep={prevStep} update={update} setLoading={setNavigating} />
      <p style={{ ...textStyles.formTitle, margin: '24px 0 8px' }}>
        Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ â E-{deal?.id}
        {state?.carTitle ? ` â ${state.carTitle}` : ''}
      </p>
      <p style={{ ...hint, marginBottom: 16 }}>
        {flow === FLOW_ECP ? 'ÐÐ¾Ð´Ð¿Ð¸ÑÐ°ÑÑ Ð­Ð¦Ð' : 'Ð Ð°ÑÐ¿ÐµÑÐ°ÑÐ°ÑÑ Ð¸ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°ÑÑ Ð² Ð¾ÑÐ¸ÑÐµ'}
        {' Â· '}
        <span
          role="button"
          onClick={() => pickFlow('')}
          style={{ color: colors.cameo, cursor: 'pointer', textDecoration: 'underline' }}
        >
          ÑÐ¼ÐµÐ½Ð¸ÑÑ ÑÐ¸Ð¿ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ
        </span>
        {resetLink ? (
          <>
            {' Â· '}
            {resetLink}
          </>
        ) : null}
      </p>
      {banner}
      <ContractForm form={form} state={state} flow={flow} isError={isError} setField={setField} setForm={setForm} />
      <Document
        file={file}
        state={state}
        form={form}
        flow={flow}
        busy={busy}
        sendingSms={sendingSms}
        signedFile={signedFile}
        setSignedFile={setSignedFile}
        uploading={uploading}
        onSendEcp={requestEcp}
        onRestartEcp={restartEcp}
        onUploadSigned={uploadSigned}
      />
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 8 }}>
        {state?.ecp?.stage === 'complete' ? null : (
          <Button
            disabled={busy}
            text={busyLabel === BUSY_GENERATE ? 'Ð¤Ð¾ÑÐ¼Ð¸ÑÑÐµÐ¼â¦' : file ? 'Ð¡ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾' : 'Ð¡ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ'}
            fill
            onClick={submit}
          />
        )}
        <Button
          disabled={busy || !canGoNext({ flow, hasFile: Boolean(file), ecp: state?.ecp, nextStep })}
          text="ÐÐ°Ð»ÐµÐµ"
          fill
          onClick={goNext}
        />
      </div>
      {file && state?.ecp?.stage !== 'complete' && (state?.ecp?.signedCount > 0 || state?.ecp?.stage === 'waiting') ? (
        <p style={{ ...hint, marginTop: 8 }}>
          ÐÑÐ¾ÑÐµÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð½Ð°ÑÐ½ÑÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.
        </p>
      ) : null}
      {overlay}
      {confirmModal}
    </div>
  );
};

export default TripartiteContractStep;
